/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


(function($) {
  	
	$(document).ready(function() {		
		manhattan.init();
	});

	var manhattan = {
        manhattanTimeout: null,
		isSidebarAjaxClick: false,
      
		init: function() {			
			this.other();
          	this.sort_by_open();
          	this.home_silder();
          	this.zoom();
          	this.qty();
          	this.cart_empty();
          	this.alert_css();
          	this.filter_open();
            this.grid_height();
            this.scrolltop();
			 
          	this.newsletter();
            
            this.section_script();
            this.shop_name();
		},
      	
      	section_script: function(){
      		var sections = new theme.Sections();
            sections.register('slideshow-section', manhattan.home_silder);
            sections.register('featured-collection', manhattan.grid_height);
            sections.register('collection-template', manhattan.collection);
            sections.register('collections-template', manhattan.collections);
            sections.register('product-template', manhattan.product);
            sections.register('contact-template', manhattan.contact);
            sections.register('lookbook-template', manhattan.look_book);
            sections.register('search-template', manhattan.search);
         
        },
      
         shop_name : function(){
           if($(window).width() < 1025){
             var shop_name = $('body').data('shop');
             if($('.shop_name').length > 0)
             {
             $('.shop_name').html('<h2 class="white_font">'+ shop_name +'</h2>');
             }
           }
		 },
      
      	collection:function(){
          manhattan.grid_height();
          manhattan.collection_filter();
           
            $( "body" ).on( "click", "#AddToCart", function(e) {
              var form = $(this).closest('form');
              manhattan.quickviewAjaxAddToCart(form);
              e.preventDefault();
            });
          
          
        },
      	
        collections: function(){
          manhattan.pro_list_slider();
          manhattan.grid_height(); 
           
            $( "body" ).on( "click", "#AddToCart", function(e) {
              var form = $(this).closest('form');
              manhattan.quickviewAjaxAddToCart(form);
              e.preventDefault();
            });
          
        },
      
        search:function(){
          manhattan.grid_height(); 
          manhattan.pro_qty();
        },
      
        contact: function(container){
          var $container = this.$container = $(container);
          var map_address = $container.attr('data-address');
          var zoom_level = $container.attr('data-zoom');
          var scrollwheel = $container.attr('data-scroll');
           if(scrollwheel == 'false'){
              var boolen_scroll = false ;
           }else{
              var boolen_scroll = true ;
           }  
           
           var latlng = new google.maps.LatLng(0, 0);
            var myOptions = {
             zoom: parseInt(zoom_level),
              center: latlng,

              scrollwheel:boolen_scroll,
              scaleControl: boolen_scroll,
              disableDefaultUI: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            var map2 = new google.maps.Map(document.getElementById("map-canvas"), myOptions);
            var geocoder_map2 = new google.maps.Geocoder();
            var address = map_address;
            geocoder_map2.geocode( { 'address': address}, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                map2.setCenter(results[0].geometry.location);

                var marker = new google.maps.Marker({
                  map: map2, 
                  position: map2.getCenter()
                });

                var contentString = map_address;
                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });

              } else {
                alert("Geocode was not successful for the following reason: " + status);
              }
            });
          
     	},
        
        product: function(container){
        	//-------- Accordion          	
            $( "#accordion" ).accordion({
              heightStyle: "content",
              collapsible: true
            });	
            
            manhattan.pro_thumb();
            manhattan.zoom();
            manhattan.product_slider();
            
          
            var $container = this.$container = $(container);
            var sectionId = $container.attr('data-section-id');

            if (!$('#ProductJson-' + sectionId).html()) {
              return;
            }
            var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
          
          	var selectCallback = function(variant, selector) {  
    		
              // BEGIN SWATCHES
              if (variant) {
                var form = jQuery('#' + selector.domIdPrefix).closest('form');
                for (var i=0,length=variant.options.length; i<length; i++) {
                  var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
                  if (radioButton.size()) {
                    radioButton.get(0).checked = true;
                  }
                }
              }
              // END SWATCHES

              hulkthemes.productPage({
                money_format: "",
                variant: variant,
                selector: selector
              });
              
            };
          
            new Shopify.OptionSelectors('productSelect', {
              product: productSingleObject,
              onVariantSelected: selectCallback,
              enableHistoryState: true
            });
          	
            
            $('.swatch').each(function() {
              var index = $(this).data('option-index');
              $('.selector-wrapper:eq('+index+')').hide();
            });
            
          	jQuery('.swatch :radio').change(function() {
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionValue = jQuery(this).val();
              jQuery(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
            });
          
             
             $("#AddToCart").click(function(e){
                var form = $(this).closest('form');
                manhattan.quickviewAjaxAddToCart(form);
                e.preventDefault();
              });
           

            // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
            if (productSingleObject.options.length == 1 && productSingleObject.options[0] != 'Title') {
              $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0"></label>');
            }

            // Hide selectors if we only have 1 variant and its title contains 'Default'.
            if (productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.toLowerCase().indexOf('default') !== -1) {
              $('.selector-wrapper').hide();
            }
        },
          
        quickviewAjaxAddToCart:function(form){
          	 $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: jQuery(form).serialize(),
                dataType: 'json',
               	beforeSend: function() {
                },
                success: function(msg) { 
                    var get_qty = $(form).find('#Quantity').val(); 
                    alert(get_qty + " item added into cart");
                    manhattan.quickviewUpdateCart();
                },
                error: function(xhr, text) {
                    $(form).find("#AddToCart").val("Add to Cart");
                  	var data = eval('(' + xhr.responseText + ')');
                     
                    $('#AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');
                     window.setTimeout(function() {
                        $(".errors.qty-error").fadeOut();
                      }, 2000);
                }
            });
        },
                    
        quickviewUpdateCart:function(){
          	jQuery.getJSON('/cart.js', function (cart, textStatus) {
                $("#CartCount").show(); 
              	$("#CartCount").html(cart.item_count).removeClass('hidden-count');
            });          	
        },  
      
        product_slider:function(){
          // ---------------- Product Slider ----------------


          $('#thumbs').owlCarousel({
              loop:true,
              margin:10,
              nav:false,
              dots:false,
              responsive:{
                  0:{
                    items:4
                  },
                  481:{
                    items:6
                  },
                  768:{
                    items:7
                  },
                  993:{
                    items:5
                  },
                  1024:{
                    items:5
                  },
                  1025:{
                    items:6
                  }
              }
          })

          if($(window).width() <= 1000){
            $('.releted_product').owlCarousel({
              loop:true,
              margin:10,
              nav:false,
              dots:false,
              responsive:{
                0:{
                  items:1
                },
                481:{
                  items:2
                },
                768:{
                  items:3
                }
              }
            })
          }
        },
        
        
        home_silder: function(container){
            var $container = this.$container = $(container);
            var id = $container.attr('data-section-id');
            var transition = $container.attr('data-transition');
            if($container.attr('data-autoplay') == 'true'){
              var autoplay = true;
            }
            else{
              var autoplay = false;
            }

            var speed = $container.attr('data-speed');

            if($container.attr('data-controls') == 'true'){
              var controls = true;
            }
            else{
              var controls = false;
            }
          
            if(transition == 'horizontal'){
              var Loop_new = false;
            }
            else{
              var Loop_new = true;
            }
          
          	   
          
          
          	//change prev /next image 
            var slider_id = $('#bxslider_'+id);
            var cont_id = $('#customNavigation_'+id);
            var slider = $('#bxslider_'+id).bxSlider({
              mode: 'fade',
  			  captions: true,
              auto: autoplay,
              pause: speed,
              controls:true,
              onSliderLoad: function() {
                  slider_id.find('> li').eq(0).addClass('active');
                  manhattan.set_next_prev_img(id);
              },
              onSlideBefore: function() {},
              onSlideAfter: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
                  slider_id.find('> li.active').removeClass('active');
                  slider_id.find('> li').eq(currentSlideHtmlObject).addClass('active');
                  manhattan.set_next_prev_img(id);
              }
            });

            $(".next").click(function(){
                $(this).parents('.hero-slider').find('.bx-next').trigger('click');
                manhattan.set_next_prev_img();
            });

            $(".prev").click(function(){
                $(this).parents('.hero-slider').find('.bx-prev').trigger('click');
                manhattan.set_next_prev_img();
            });          
        },
          
        set_next_prev_img: function(id){
          var first_img = $('#bxslider_'+id).find('> li:first img').attr('src');
          var last_img = $('#bxslider_'+id).find('> li:last img').attr('src');
          var next_img  = $('#bxslider_'+id).find('> li.active').next().find('img').attr('src');
          var prev_img  = $('#bxslider_'+id).find('> li.active').prev().find('img').attr('src');

          if($('#bxslider_'+id).find('> li:first').hasClass('active')){
              $('#customNavigation_'+id).find('.next div img').attr('src',next_img);
              $('#customNavigation_'+id).find('.prev div img').attr('src',last_img);
          }
          else if($('#bxslider_'+id).find('> li:last').hasClass('active')){
              $('#customNavigation_'+id).find('.next div img').attr('src',first_img);
              $('#customNavigation_'+id).find('.prev div img').attr('src',prev_img);
          }
          else{
              $('#customNavigation_'+id).find('.next div img').attr('src',next_img);
              $('#customNavigation_'+id).find('.prev div img').attr('src',prev_img);
          }
        },  
        
      	other:function(){
            

           
            $('a[href*="#"]:not([href="#"])').click(function() {
              if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                  $('html, body').animate({
                    scrollTop: target.offset().top
                  }, 1000);
                  return false;
                }
              }
            });
            
            $(window).load(function(){
          		manhattan.resizeContent();   
                $('body').css('opacity', '1');
                $('header').addClass('load_border');
            });
          	$(window).resize(function() {
                manhattan.resizeContent();
            });  
          
			var footer_height = $('footer').outerHeight();
            $('.footer_blank').css('height', footer_height);

            $('.wishlist_top').click(function(e) {
                $('.wishlist_overlay').addClass('pop_class');
                $('body').css('overflow', 'hidden');
            });

            $('.site-header__cart-toggle.cart_top').click(function(e) {
                $('.cart_overlay').addClass('pop_class');
                $('body').css('overflow', 'hidden');
            });


            $('.close').click(function(e) {
                $('.overlay').removeClass('pop_class');
                $('body').css('overflow', 'auto');
            });
          
          	//--------- add to cart
          	$('.add_to_cart_button').click(function(e) {
                $(this).addClass('added_item');
            });
          
            //-------- Responsive
          	$('header nav').meanmenu();
          
          	if($(window).width() > 1024){
         		 new WOW().init();
          	}
          
          	//-------- Accordion          	
            $( "#accordion" ).accordion({
              heightStyle: "content",
              collapsible: true
            });	
          		
            //--------- collection page 
            setTimeout(function(){
              if($("#recently-viewed-products .recent_item").length == 0) {
                $(".recently_view_item").hide();  
              }
            }, 1000);  
          
          	// accordation for faqs page
            $(function() {
                $("#accord").accordion({
                  collapsible: true,
                  heightStyle: "content"
                });
            });
          
        },
      
        sort_by_open: function(){
			//----- Shorting Dropdown
          	$('.filter-sortby .dropdown-toggle').click(function(e) {
                $('.filter-sortby ul.dropdown-menu').slideToggle('fast');
                 event.stopPropagation();
            });

            $(document).click(function(){
                 $('.filter-sortby ul.dropdown-menu').slideUp();
            });
        },
      
        resizeContent: function(){
          	var height_screen = $(window).height();
            $('.hero-slider ul li').height(height_screen);
            $('.hero-slider').height(height_screen);
          
            //header menu
            if($( window ).width() < 1024 ){              
              height_screen = $(window).height();
              menu_height = height_screen - 55;
              $('.mean-container .mean-bar .mean-nav').css({"overflow-y": "scroll", "max-height": menu_height});
            }
        },
      	
      	pro_thumb: function(){
          $('#thumbs div img').click(function(e) {
              var src = $(this).data('src');
              $('#ProductPhotoImg').attr("src",src);
              
            	var window_width = $( window ).width();
  				if(window_width > 1024){
              		$("#ProductPhotoImg").elevateZoom({zoomType: "inner",cursor: "crosshair",divId: "zoomDivPro"});
                }
              
          });
        },
      
        zoom: function(){
			//zoom on featured image
            
              var window_width = $( window ).width();
              if(window_width > 1024){
              	   $("#ProductPhotoImg").elevateZoom({zoomType: "inner",cursor: "crosshair",divId: "zoomDivPro"});
              }
            
        },
          
        qty: function(){
			// --------------- Cart page -----------------
            $(".cart-items .cart-item .cart-qty #plus").each(function(index,element){
              $(this).click(function(){
                var getval = $(this).parent().find("#quantity").val();
                getval++;
                $(this).parent().find("#quantity").val(getval);
                $("#con_shopping").trigger('click');
              });
            });
            $(".cart-items .cart-item .cart-qty #minus").each(function(index,element){
              $(this).click(function(){
                var getval = $(this).parent().find("#quantity").val();
                if(getval != 1){
                  getval--;
                  $(this).parent().find("#quantity").val(getval);
                  $("#con_shopping").trigger('click');
                }		
              });
            });
          
            
        },
      
      	cart_empty: function(){
         	 var total_cart_item = $("#CartCount").text();
              if(total_cart_item == ""){
                  $("#CartCount").hide();
              }
        },	
      
      	alert_css: function(){
      		window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
    	},
      	
        look_book: function(){
          	// ------- Masonry ---------
            if($(window).width() <= 767 && $(window).width() >= 480){
              $('.lookbook_items').BlocksIt({
                numOfCol: 2,
              });
            }
            else if($(window).width() < 480){
              $('.lookbook_items').BlocksIt({
                numOfCol: 1,
              });
            }
            else{
              $('.lookbook_items').BlocksIt({
                numOfCol: 3,
              });
            }

            // --------------------- Lookbook hover ---------------------
            $('.lookbook_items .look_grid').each(function(index, element) {
              var height_overlay = $(this).height()-30;
              var Width_overlay = $(this).width()-30;
              $('.lookbook_overlay',this).css('height',height_overlay);
              $('.lookbook_overlay',this).css('width',Width_overlay);
            });
            
        },
      
        pro_list_slider: function() {
            if($(window).width() <= 1024){
				$('.product_list').owlCarousel({
				loop:false,
				nav:true,
				margin:10,
                dots:false,
				responsive:{
					0:{
						items:1,
                      	dots:true
					},
					480:{
						items:1,
                      	dots:true
					},
					481:{
						items:2,
                      	dots:true
					},
					650:{
						items:2,
                      	dots:true
					},
					651:{
						items:3,

                      	dots:true
					},
					768:{
						items:3,
						margin:10,
                      	dots:true
					},
					1024:{
						items:4,
						margin:10
					},
					1200:{
						items:4,
					},
					1201:{
						items:4,
						loop:false,
						nav:false,
						dots:false
					}
				}
			});
            }  
        },       
      
        filter_open: function(){
          $(".filter_toggle").click(function(){
            	$(".sidebar_section").addClass("active");
                $('body').addClass('body_blur');
          });
          $(".back_arrow").click(function(e) {
            $('.sidebar_section').removeClass('active');
            $('body').removeClass('body_blur');
          });
        },
      
      	grid_height: function(){	
          $('.product_grid_list .grid__item .product_image').responsiveEqualHeightGrid();
          
		}, 
      
        collection_filter: function() {
          manhattan.sidebarParams(); 
          if ($(".sidebar_section").length > 0) {        	                                   
            manhattan.sidebarMapClear();
            manhattan.sidebarMapClearAll();
          }
          manhattan.sidebarMapPaging();
          manhattan.sidebarMapEvents();
        },
      
      	sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
      
      	sidebarMapTagEvents: function() {            
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function(e) {
                var currentTags = [];
                var check_radio =  $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if(check_radio == "radio"){                 
                //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val();                
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);                    
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                manhattan.sidebarAjaxClick();
                e.preventDefault();
            });
        },
      
      	sidebarMapCategories: function() {
            $(".category_section .sidebar-links a").click(function(e) {           	
                if (!$(this).parent().hasClass('active_collection')) {                	
                    delete Shopify.queryParams.q;
                    manhattan.sidebarAjaxClick($(this).attr('href'));
                }
                e.preventDefault();
            });
        },

        sidebarMapSorting: function(e) {  
          var sort_name = $("#sort_by li a.active").text();
          if(sort_name != ""){
            $(".filter-sortby button").html("Sort By "+sort_name+'<span><i class="entypo-down-open"></i></span>');
          } 
          $(".filter-sortby .dropdown-menu a").click(function(){  
             Shopify.queryParams.sort_by = $(this).attr("name");              
             manhattan.sidebarAjaxClick();
          });       
        
        },

        sidebarMapEvents: function() {
            manhattan.sidebarMapTagEvents();
           	manhattan.sidebarMapCategories();
            manhattan.sidebarMapSorting();
        },

        sidebarMapPaging: function() {
            $(".collection-filter .pagination a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if(page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = manhattan.sidebarCreateUrl();
                        manhattan.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        manhattan.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
        },

        sidebarMapClearAll: function() {
            //clear all selection
             $('a.clear_all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;                
              	manhattan.sidebarAjaxClick();
                e.preventDefault();                
            });
        },

        sidebarMapClear: function() {            
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if(sidebarTag.find("input:checked").length > 0) {
                    $('.back_clear').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display","block").click(function(e) {
                        var currentTags = [];
                        if(Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if(tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if(currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        manhattan.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },

        sidebarCreateUrl: function(baseLink) {        	
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }else{
            	if (newQuery != "")
	              return location.pathname + "?" + newQuery;
	            else
	              return location.pathname + newQuery;
            }
            //return location.pathname + "?" + newQuery;
        },

        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = manhattan.sidebarCreateUrl(baseLink);  
            manhattan.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            manhattan.sidebarGetContent(newurl);            
        },
      	
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    manhattan.showLoading();
                },
                success: function(data) {
                    manhattan.sidebarMapData(data);
                    manhattan.sidebarMapPaging();
                  	manhattan.sort_by_open();
                  	if ($(".sidebar_section").length > 0) {    
                      manhattan.sidebarMapTagEvents();
                      manhattan.sidebarMapCategories();
                      manhattan.sidebarMapClear();
                      manhattan.sidebarMapClearAll();
                    }                    
                    manhattan.sidebarMapSorting();                    
                     
                      $( "body" ).on( "click", "#AddToCart", function(e) {
                        var form = $(this).closest('form');
                        manhattan.quickviewAjaxAddToCart(form);
                        e.preventDefault();
                      });
                     
                  	setTimeout(function() {                      
                  		manhattan.grid_height();
                     }, 1000);
                  	manhattan.hideLoading();   
                  	
                  	
                  	
                },
                error: function(xhr, text) {
                    manhattan.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                }
            });
        },
      
		showLoading: function() {
            $('.loading-modal').show();
        },
      
      	hideLoading: function() {
            $('.loading-modal').hide();
        },
      
        sidebarMapData: function(data) { 
          //console.log(data);
            var currentList = $(".product_listing > .grid ");
            if (currentList.length == 0) {
                currentList = $(".product_listing > .grid");
            }

            var productList = $(data).find(".product_listing > .grid");
            if (productList.length == 0) {
                productList = $(data).find(".product_listing > .grid");
            }
            currentList.replaceWith(productList);
          
            //replace sidebar
          	$(".shop_filter").replaceWith($(data).find(".shop_filter"));  
            
            //replace paging 
            if ($(data).find(".pagination").length > 0) {
            	$(".pagination").show();
                $(".collection-filter").replaceWith($(data).find(".collection-filter"));
            }else{
            	$(".pagination").hide();
            }

            //replace tags            
           // $(".filter_sidebar").replaceWith($(data).find(".filter_sidebar"));       
			
           //replace sort by            
           $(".filter-sortby").replaceWith($(data).find(".filter-sortby"));       
			
           
          	//replace showing product
            if ($(data).find(".page_item p").length > 0) {
            	$(".page_item p").show();
                $(".page_item").replaceWith($(data).find(".page_item"));
            }else{
            	$(".page_item p").hide();
            }                    	
          	
          	//replace Collection banner
          	$(".breadcrumb_section").closest(".header_banner").replaceWith($(data).find(".breadcrumb_section").closest(".header_banner")); 	
          
          
            // for mobile filter 
            $(".sidebar_section").removeClass("active");
            $('body').removeClass('body_blur');

            $(".back_arrow").click(function(e) {  
				$('.sidebar_section').removeClass('active');
				$('body').removeClass('body_blur');
			});
          	
        },	
      
        scrolltop :function(){
            $('#scrollToTop').bind("click", function () {
              $('html, body').animate({ scrollTop: 0 }, 800);
              return false;
            });
          },
      
      	newsletter: function() {
          //===   NEASLETTER POPUP
          $(window).load(function(){
            setTimeout( function() {
              var check_cookie = $.cookie('mailing_list_popup');

              $('.newsletter_popup .close_btn').click(function(e) {
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_overlay").removeClass('newsletter_popupactive');
                $('body').removeClass('overflow_hidden');
              });

              if(check_cookie == null){
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_overlay").addClass('newsletter_popupactive');
                $('body').addClass('overflow_hidden');
              }
              else if(check_cookie < 1){
                x = $.cookie('mailing_list_popup');
                y = 1;
                var z = +x + +y;
                $.cookie('mailing_list_popup', z, { expires: 31 });
                $(".newsletter_overlay").addClass('newsletter_popupactive');
                $('body').addClass('overflow_hidden');
              }
            }, 3000);
          }); 
        }
    }
})(jQuery);      





// ====================== Document.ready ===========================
$(document).ready(function() {

    // -----------------------Fixed header

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header').outerHeight();

    $(window).scroll(function(event){
      didScroll = true;
    });

    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);
    hasScrolled();

    function hasScrolled() {
      var st = $(this).scrollTop();

      if(Math.abs(lastScrollTop - st) <= delta)
        return;
      if (st > lastScrollTop && st > navbarHeight){
        $('header').removeClass('nav-down').addClass('nav-up');
      } else {
        if(st + $(window).height() < $(document).height()) {
          if(st==0){
            $('header').removeClass('nav-up').removeClass('nav-down');
          }
          else{
            $('header').removeClass('nav-up').addClass('nav-down');
          }
        }
      }
      lastScrollTop = st;
    }

	$('.search_ico_top').click(function(e) {
      e.preventDefault();
      $('.search_overlay').addClass('pop_class');
      $('body').css('overflow', 'hidden');
    });
  
	$(".meanmenu-reveal").click(function(){
        $('body').toggleClass('body-overflow');
    });
  
  	
  
}); 
  
  // --------------- Product page -----------------
    function plus(){
      var getval = $('#Quantity').val();
      getval++;
      $('#Quantity').val(getval);
    };

    function minus(){
      var getval = $('#Quantity').val();
      if(getval != 1){
        getval--;
      }
      $('#Quantity').val(getval);
    };




